__turbopack_context__.v({
  "className": "jetbrains_mono_d35c57c5-module__G7wv4a__className",
  "variable": "jetbrains_mono_d35c57c5-module__G7wv4a__variable",
});
